package org.zq.flvtomp4.platform

import org.w3c.files.File
import kotlin.js.Date

/**
 * 浏览器端文件仓库：用虚拟路径关联真正的 File / Blob。
 */
object WebFileStore {
    private var seq = 0
    private val inputs = mutableMapOf<String, File>()
    private val outputs = mutableMapOf<String, Pair<String, dynamic>>()

    fun registerInput(file: File): String? {
        val name = file.name
        if (!name.endsWith(".flv", ignoreCase = true)) return null
        val path = "web-input://${++seq}/$name"
        inputs[path] = file
        return path
    }

    fun registerInputs(files: List<File>): List<String> =
        files.mapNotNull { registerInput(it) }

    fun getInput(path: String): File? = inputs[path]

    fun registerOutput(path: String, fileName: String, data: dynamic) {
        outputs[path] = fileName to data
    }

    fun downloadOutput(path: String): Boolean {
        val entry = outputs[path] ?: return false
        downloadBytes(entry.first, entry.second)
        return true
    }

    fun downloadBytes(fileName: String, data: dynamic) {
        val downloader = js("window.__downloadMp4")
        if (downloader == null) {
            error("下载组件未就绪，请刷新页面")
        }
        downloader(fileName, data)
    }

    fun defaultOutputPath(inputPath: String): String {
        val name = inputPath.substringAfterLast('/').substringBeforeLast('.') + ".mp4"
        return "web-output://${Date().getTime()}/$name"
    }
}
